import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { OperationalConfigurationEdit } from "../../components/OperationalConfigurations/OperationalConfigurationEdit";

interface OperationalConfigurationAddPageProps {
	// product id
	productId: string;
}

const useStyles = makeStyles((theme) => ({
	wrapper: {
		marginBottom: theme.spacing(4),
		maxWidth: 1024,
	},
	title: {
		marginBottom: theme.spacing(4),
	},
}));

/**
 * Page to display a page to add a feature toggle
 * @param props
 */
export const OperationalConfigurationAddPage = (props: OperationalConfigurationAddPageProps) => {
	const classes = useStyles();

	return (
		<div className={classes.wrapper} data-testid="operational-configuration-add-page">
			<Typography className={classes.title} variant="h4">
				New Operational Configuration
			</Typography>

			<OperationalConfigurationEdit productId={props.productId} />
		</div>
	);
};
